export type TForcePathFromRoute = {
  siteRoute: {
    path: string;
    exact?: boolean;
    strict?: boolean;
  };
  forcePath: string;
};

export type TForcePathsFromRoutes = (routes: Record<string, string>) => TForcePathFromRoute[];

export type TConnatixVideoAdsConfig = {
  embedScriptUrl: string;
  playerElementId: string;
};

export const CONNATIX_VIDEO_ADS_CONFIG: TConnatixVideoAdsConfig = {
  embedScriptUrl: 'https://cdn.jwplayer.com/v2/sites/2tV9yunA/placements/8QqWbeg6/embed.js',
  playerElementId: 'rio-connatix-outstream'
};

// Primis tag ids (the `s=` parameter of liveView.php). Each can be overridden by environment:
// PRIMIS_PLAYER_ID, PRIMIS_DOCKED_PLAYER_ID, PRIMIS_MOBILE_PLAYER_ID.
export type TPrimisVideoAdsConfig = {
  // Sticky player on desktop, and on mobile until a mobile id is set.
  playerId: string;
  // Flow player for the in-content docked slot.
  dockedPlayerId: string;
  // Tag used instead of the sticky player on mobile viewports; empty keeps the sticky player.
  mobilePlayerId: string;
};

export const PRIMIS_VIDEO_ADS_CONFIG: TPrimisVideoAdsConfig = {
  playerId: '122375',
  dockedPlayerId: '122580',
  mobilePlayerId: ''
};
